import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES, PRICE, loserPoints, offerItems } from '../data/offer';
import { ArrowDownIcon, CheckIcon, ClockIcon, CrossIcon, HookIcon, PdfIcon, ShieldIcon, StarIcon } from './icons/CraftIcons';
import { CountdownDigits } from './CountdownDigits';
import { CtaButton } from './CtaButton';
const mainItem = offerItems[0];
export function PriceDuelHero() {
  return <section aria-labelledby="hero-headline" className="relative w-full overflow-hidden bg-cream px-4 pb-10 pt-6 sm:px-6 sm:pb-16 sm:pt-10 lg:pb-24 lg:pt-14" data-id="element-309" data-mp="779hiz3yquyk">
      {/* soft stage lighting */}
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 hidden h-72 w-72 rounded-full bg-gold/10 blur-2xl sm:block" data-id="element-310" data-mp="3uiix5xdqesiv" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -left-20 hidden h-72 w-72 rounded-full bg-sage/10 blur-2xl sm:block" data-id="element-311" data-mp="q4ke2by7naab" />

      <div className="relative mx-auto max-w-[1180px]" data-id="element-312" data-mp="13qyofp6w3vh0">
        {/* ── Referee line ───────────────────────────── */}
        <div className="mx-auto max-w-3xl text-center" data-id="element-313" data-mp="yswv8bfr2frt">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 rounded-full border border-gold/45 bg-gold-tint px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-dark" data-id="element-314" data-mp="yqanobsv009l">
            <HookIcon className="h-3.5 w-3.5" data-id="element-315" data-mp="1if2yy5vsh0op" />
            The verdict is in
          </motion.span>

          <motion.h1 id="hero-headline" initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.08
        }} className="mt-4 font-display text-[28px] font-bold leading-[1.14] tracking-tight text-ink text-balance sm:text-4xl lg:text-[44px]" data-id="element-316" data-mp="1weujyqkq3hc7">
            Is It Actually Possible to Be This{' '}
            <em className="italic text-crimson" data-id="element-317" data-mp="1x6chdcns0dct">&ldquo;Stupid&rdquo;</em> With Your Money?
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.16
        }} className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-318" data-mp="224nq1k2c4htg">
            You Are Currently Paying{' '}
            <strong className="font-bold text-ink" data-id="element-319" data-mp="2g1stdcanz2l0">${PRICE.singlePattern} For ONE Single Pattern</strong>
            ... While Professional Makers Are Getting{' '}
            <strong className="font-bold text-ink" data-id="element-320" data-mp="2purjwzpq1379">1,000+ Viral Designs</strong>, A Business Roadmap,
            and A Branding Kit For{' '}
            <span className="font-extrabold text-gold-dark" data-id="element-321" data-mp="2txebr0me6o4g">
              Less Than The Price of a Large Pizza.
            </span>
          </motion.p>
        </div>

        {/* ── The duel ───────────────────────────────── */}
        <div className="perspective-stage relative mt-7 sm:mt-10 lg:mt-14" data-id="element-322" data-mp="3dx4xwtxayyru">
          {/* dashed divider between the two contenders */}
          <div aria-hidden="true" className="dashed-rule absolute left-[26%] top-6 hidden w-[2px] lg:block" style={{
          height: 'calc(100% - 3rem)'
        }} data-id="element-323" data-mp="38xjxsg6eckdj" />

          <div className="flex flex-col items-center gap-5 sm:gap-8 lg:flex-row lg:items-center lg:gap-0" data-id="element-324" data-mp="2zyygspgkpdev">
            {/* LOSER — Option A */}
            <motion.article initial={{
            opacity: 0,
            x: -30,
            rotate: -10
          }} animate={{
            opacity: 1,
            x: 0,
            rotate: -6
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="relative w-full max-w-[280px] shrink-0 rounded-3xl border border-[#D9D3C4] bg-[#EDEAE1] px-4 py-5 text-center shadow-soft grayscale-[55%] lg:w-[250px] lg:max-w-none" data-id="element-325" data-mp="kcp822vbqf8">
              <div className="animate-slump" data-id="element-326" data-mp="eib02xhzd4pz">
                <span className="inline-block rounded-full bg-[#DCD7C9] px-2.5 py-1 text-[9.5px] font-extrabold uppercase tracking-[0.1em] text-ink-soft" data-id="element-327" data-mp="ehhpflfwhv2k">
                  Option A
                </span>
                <PdfIcon className="mx-auto mt-3 h-16 w-16 text-[#B7B29F]" strokeWidth={1.6} data-id="element-328" data-mp="40xnwa6dyryc" />
                <h2 className="mt-3 text-base font-extrabold text-ink-soft" data-id="element-329" data-mp="3m6am3rcp1r8o">One Single Pattern</h2>
                <p className="mt-1 font-display text-4xl font-extrabold leading-none text-ink-faint" data-id="element-330" data-mp="3q7cf3qg0p727">
                  ${PRICE.singlePattern}
                </p>
                <p className="mt-1 text-[9.5px] font-bold uppercase tracking-wide text-ink-soft" data-id="element-331" data-mp="mqdpl0tt4qgc">
                  Per pattern. Every time.
                </p>
                <ul className="mt-4 space-y-0 text-left" data-id="element-332" data-mp="8wd0yzwkkjtp">
                  {loserPoints.map(point => <li key={point} className="flex items-center gap-2 border-t border-dashed border-[#D9D3C4] py-2 text-[11px] text-ink-soft first:border-t-0" data-id="element-333" data-mp="cxogudpn5qop">
                      <CrossIcon className="h-3.5 w-3.5 shrink-0 text-crimson/70" data-id="element-334" data-mp="2q6h9bp2geec9" />
                      {point}
                    </li>)}
                </ul>
              </div>
              <span className="absolute left-1/2 top-[42%] -translate-x-1/2 -rotate-[16deg] animate-stamp rounded-lg border-[3px] border-crimson/55 px-2.5 py-1 text-sm font-extrabold uppercase tracking-[0.15em] text-crimson/65" data-id="element-335" data-mp="2zwamuvm5p3j5">
                Overpriced
              </span>
            </motion.article>

            {/* VS medal */}
            <div className="relative z-20 -my-3 sm:-my-4 lg:-mx-9 lg:my-0" data-id="element-336" data-mp="22a3i9lpurb6s">
              <motion.div initial={{
              opacity: 0,
              scale: 0.5
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.45
            }} className="flex h-16 w-16 animate-medal items-center justify-center rounded-full border-[3px] border-ivory bg-[radial-gradient(circle_at_35%_30%,#F3ECD9,#D6B15B_60%,#9C7A28_100%)] shadow-[0_14px_26px_rgba(43,42,38,0.3)] lg:h-[74px] lg:w-[74px]" data-id="element-337" data-mp="2h6cgql1x5ki5">
                <span className="font-display text-lg font-extrabold text-[#4A3714] lg:text-xl" data-id="element-338" data-mp="3j1oplys2h7j">
                  VS
                </span>
              </motion.div>
            </div>

            {/* WINNER — Option B */}
            <motion.article initial={{
            opacity: 0,
            y: 40,
            rotateY: -8
          }} animate={{
            opacity: 1,
            y: 0,
            rotateY: -3
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="relative z-10 w-full rounded-[26px] border-2 border-gold bg-ivory px-5 pb-5 pt-6 shadow-lift sm:px-7 lg:flex-1" data-id="element-339" data-mp="dhr6zful63ob">
              <div className="animate-floaty" data-id="element-340" data-mp="3lvpzg7icn6x2">
                <span className="absolute -right-2 top-4 flex rotate-[4deg] items-center gap-1.5 rounded-l-lg rounded-r bg-gradient-to-br from-gold-light to-[#B3852B] px-3.5 py-1.5 text-[11px] font-extrabold tracking-wide text-white shadow-gold" data-id="element-341" data-mp="3qo9d14h1e21v">
                  <StarIcon className="h-3.5 w-3.5" data-id="element-342" data-mp="2y5m2gizo25f1" />
                  WINNER
                </span>

                <span className="inline-flex items-center gap-1.5 rounded-full bg-sage-tint px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-sage-dark" data-id="element-343" data-mp="1fa825mm6x2rh">
                  <ShieldIcon className="h-3 w-3" data-id="element-344" data-mp="16aconb55wvoa" />
                  Option B — The CEO Move
                </span>
                <h2 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-gold-dark sm:text-3xl" data-id="element-345" data-mp="11cb4emw02qb8">
                  The Entire Treasury
                </h2>

                {/* bundle + countdown */}
                <div className="mt-4 flex flex-col gap-4 sm:flex-row" data-id="element-346" data-mp="rkwwbqpzgi6h">
                  <div className="relative flex h-[150px] w-full shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-hairline bg-linen shadow-inset sm:h-[130px] sm:w-[190px]" data-id="element-347" data-mp="nlo6uy1z76gq">
                    <motion.img src={IMAGES.bundle} alt="The Modern Maker's Vault digital bundle: treasury book, amigurumi tablet, Etsy SEO workbook, viral hooks phone and branding cards" className="w-[94%] object-contain drop-shadow-[0_10px_10px_rgba(43,42,38,0.28)]" loading="eager" decoding="async" width={1376} height={768} initial={{
                    rotateY: -14,
                    scale: 0.94
                  }} animate={{
                    rotateY: -8,
                    scale: 1
                  }} transition={{
                    duration: 0.9,
                    delay: 0.5
                  }} data-id="element-348" data-mp="dm6yg8vcaeh2" />
                  </div>

                  <div className="flex flex-1 flex-col justify-center gap-1 rounded-2xl border border-crimson/30 bg-crimson-tint px-4 py-3" data-id="element-349" data-mp="1imwsgy4ky2i1">
                    <span className="flex items-center gap-1.5 text-[10.5px] font-extrabold uppercase tracking-[0.1em] text-crimson" data-id="element-350" data-mp="19rp8e04nicjf">
                      <ClockIcon className="h-3.5 w-3.5" data-id="element-351" data-mp="uvrg4sxulsch" />
                      Closes forever in
                    </span>
                    <CountdownDigits className="text-3xl text-crimson sm:text-[34px]" data-id="element-352" data-mp="zw5f7lhh1ryd" />
                    <span className="text-[10px] font-semibold text-crimson-soft" data-id="element-353" data-mp="galobtb6shw9">
                      This ${PRICE.totalValue} bundle disappears at zero.
                    </span>
                  </div>
                </div>

                {/* headline value line */}
                <div className="mt-4 flex items-center justify-between gap-3 border-t border-dashed border-hairline pt-3" data-id="element-354" data-mp="l6uc1v3g9jf1">
                  <span className="flex items-center gap-2 text-xs font-semibold text-ink sm:text-sm" data-id="element-355" data-mp="z5aevay6yprw">
                    <CheckIcon className="h-4 w-4 shrink-0 text-sage" data-id="element-356" data-mp="v3p6a1sowxni" />
                    {mainItem.title} (&ldquo;Chicken Bag&rdquo; &amp; more)
                  </span>
                  <span className="font-bold text-ink-soft" data-id="element-357" data-mp="13zeq46ehpjys">${mainItem.value}</span>
                </div>
                <p className="mt-1.5 pl-6 text-[11px] italic text-ink-soft" data-id="element-358" data-mp="1ivvw0i3wu6dy">
                  + 7 more bonuses — SEO Secrets, Pricing Calculator, Branding Kit, Full Commercial
                  License &amp; more
                </p>

                <div className="my-3 h-px bg-hairline" data-id="element-359" data-mp="k4l1mnog4igh" />

                {/* totals */}
                <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-360" data-mp="k2rs90mg7k4s">
                  <div data-id="element-361" data-mp="f5rlsolosfd5">
                    <p className="text-[11px] font-bold uppercase tracking-wide text-ink-soft" data-id="element-362" data-mp="b3wnlsz1yi3l">
                      Total real world value
                      <span className="ml-1.5 font-extrabold text-crimson line-through" data-id="element-363" data-mp="17t4ab4beqx93">
                        ${PRICE.totalValue}.00
                      </span>
                    </p>
                    <p className="mt-0.5 text-[10.5px] font-extrabold uppercase tracking-wide text-gold-dark" data-id="element-364" data-mp="yspl3tvboy0b">
                      Your price today
                    </p>
                    <p className="font-display text-4xl font-extrabold leading-none text-gold-dark sm:text-[42px]" data-id="element-365" data-mp="3jjgbsdkv9abs">
                      ${PRICE.today}.00
                    </p>
                  </div>
                  <span className="rounded-lg border border-sage/30 bg-sage-tint px-3 py-2 text-[11px] font-extrabold text-sage-dark" data-id="element-366" data-mp="1u2ul4gwjtlv1">
                    SAVE ${PRICE.savings}
                  </span>
                </div>

                <CtaButton className="mt-4" label={`YES! GIVE ME THE $${PRICE.totalValue} TREASURY FOR ONLY $${PRICE.today}`} subLabel="Instant PDF access · One-time payment" data-id="element-367" data-mp="2330vvv0v47qi" />
              </div>
            </motion.article>
          </div>
        </div>

        <p className="mt-7 flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft sm:mt-10" data-id="element-368" data-mp="2hqltxaivrgrk">
          <ArrowDownIcon className="h-4 w-4 animate-floaty text-sage" data-id="element-369" data-mp="2qsv2huul902b" />
          Here&rsquo;s the brutal math
        </p>
      </div>
    </section>;
}